import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';
import ModalWithActions from '../../ModalWithActions';
import CheckboxList from '../../shared/molecules/CheckboxList';

const SensorTypeSensorsModal = ({
  modalShow,
  onSenderModalHide,
  onSubmit,
  onCancel,
  sensors,
  sensorTypeName,
  changedMeasuringMode,
  changedMeasuringUnit,
  changedThresholds,
}) => {
  const { t } = useTranslation();
  const [checked, setChecked] = useState(sensors.map(s => s.id));

  return (
    <ModalWithActions
      show={modalShow}
      modalTitle={t(
        'management_menu.sensor_library.sensors_modal.update_sensors',
      )}
      action={async () => {
        await onSubmit(checked);
        onSenderModalHide();
      }}
      onHide={() => {
        onSenderModalHide();
        onCancel?.();
      }}
      preventClickOutside
      width="600px"
      inputComponent={
        <Stack padding="0 18px">
          <Typography textAlign="left" paddingBottom="16px">
            {t(
              'management_menu.sensor_library.sensors_modal.sensor_type_name',
              { sensorTypeName },
            )}
            {changedMeasuringMode &&
              t(
                'management_menu.sensor_library.sensors_modal.measuring_mode_changes',
              )}
            {changedThresholds &&
              !changedMeasuringMode &&
              t('management_menu.sensor_library.sensors_modal.select_sensors')}
            {changedMeasuringUnit &&
              t('management_menu.sensor_library.sensors_modal.unit_changes')}
          </Typography>
          <CheckboxList
            options={sensors.map(s => ({
              value: s.id,
              label: s.name,
            }))}
            setChecked={setChecked}
            checked={checked}
            backgroundColor="inherit"
            textColor="white"
            disabled={
              changedMeasuringMode ||
              (!changedThresholds && changedMeasuringUnit)
            }
          />
        </Stack>
      }
    />
  );
};

SensorTypeSensorsModal.propTypes = {
  changedMeasuringMode: PropTypes.bool.isRequired,
  changedMeasuringUnit: PropTypes.bool.isRequired,
  changedThresholds: PropTypes.bool.isRequired,
  modalShow: PropTypes.bool.isRequired,
  sensors: PropTypes.array.isRequired,
  onSenderModalHide: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  sensorTypeName: PropTypes.string.isRequired,
};

export default SensorTypeSensorsModal;
